export interface TagList
{
    id: string,
    tagName: string,
    tagsCategories: string,
    color: number,
    colorHex: string,
    status: string
}

export function TagListDefaultValues():TagList
{
    return {
      id: '',
      tagName: '',
      tagsCategories: '',
      color: 0,
      colorHex: '',
      status: ''
    };
}
